module.exports = (__webpack_require__(1397))(72);